import React                                                        from 'react';
import { withStyles }                                               from '@material-ui/core/styles';
import {globales,funciones}                                         from '../../global';
import BarraBotones                                                 from '../../components/Barra_menu';
import AuthService                                                  from '../../AuthService';
import Request                                                      from 'superagent';
import CustomTable                                                  from '../../components/CustomTable';
import {Table}                                                      from '@devexpress/dx-react-grid-material-ui';
import TableRowsIndexer                                             from '../../components/tableRowsIndexer'
import Dialog                                                       from '@material-ui/core/Dialog';
import DialogContent                                                from '@material-ui/core/DialogContent';
import DialogTitle                                                  from '@material-ui/core/DialogTitle';
import CircularProgress                                             from '@material-ui/core/CircularProgress';
import Backdrop                                                     from '@material-ui/core/Backdrop';
import Autocomplete                                                 from '@material-ui/lab/Autocomplete';
import {Typography,TextField}                                       from '@material-ui/core';
import Icono                                                        from '../../components/Icono'
import Button                                                       from '@material-ui/core/Button';
import Divider                                                      from '@material-ui/core/Divider';

let Auth          = new AuthService();
var ip            =globales.ip
var border_dialog =globales.border_dialog
var movil         =/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
var movil_pequeño =/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let isVisibleRowSelected = false;


const getRowId = row => row.ID_FACTURA;

/*                           CLASES DE ESTILO                       */

var styles = theme =>({
    Dialog:{
        borderRadius: border_dialog,
        margin:0,
        padding:0
    },
    backdrop: {
      zIndex: 500000,
      color: '#fff', 
      flexDirection: 'column'
    },
    select: { //CONFIGURA EL SELECT 
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'50%',
      },
      textField: {
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'20%',
        width: '20%'      
      },
    })


    const columns= movil_pequeño?[
      {name:'BOTON'      ,title: ' '},
      {name:'ID_FACTURA'    ,title: 'Factura'},
      {name:'FECHA_PROCESO' ,title: 'Fecha'},
      {name:'DESCRIPCION'   ,title: 'Descripción'},
      {name:'MONTO'         ,title: 'Monto'},
      {name:'SIMBOLO'       ,title: 'SIMBOLO'},
      {name:'ELIMINAR'      ,title: 'ELIMINAR'},
    ]:
    [
    {name:'ID_FACTURA'    ,title: 'Factura'},
    {name:'FECHA_PROCESO' ,title: 'Fecha'},
    {name:'DESCRIPCION'   ,title: 'Descripción'},
    {name:'MONTO'         ,title: 'Monto'},
    {name:'SIMBOLO'       ,title: 'SIMBOLO'},
    {name:'ELIMINAR'      ,title: 'ELIMINAR'},
    {name:'BOTON'      ,title: ' '},
    ];

    const defaultHiddenColumnNames= ['SIMBOLO','ELIMINAR'];

    const tableColumnExtensions= [
      { columnName: 'ID_FACTURA', wordWrapEnabled: false, align: 'center',width:movil_pequeño?80:120},
      { columnName: 'FECHA_PROCESO', wordWrapEnabled: false, align: 'center',width:movil_pequeño?100:130},
      { columnName: 'DESCRIPCION', wordWrapEnabled: false, align: 'left',width:movil_pequeño?180:window.innerWidth-(120+130+120+120+100)},
      { columnName: 'MONTO', wordWrapEnabled: false, align: 'center',width:movil_pequeño?100:120},
      { columnName: 'BOTON', wordWrapEnabled: false, align: 'center',width:movil_pequeño?100:120},
    ];

/*                                        EXPORT                                      */
export default withStyles(styles)(
    class TramitesAlumno extends React.Component {
      tablaRef = React.createRef();

      constructor(props) {
        super(props);
        
        this.l= props.l
        this.e= props.e
        this.i= props.i
        this.isVisibleRowSelected=isVisibleRowSelected
        this.actualizarbarra=props.actualizarbarra
        this.actualizarcircular=props.actualizarcircular

        this.state = {
            openBackDrop:      false, 
            isLoggin:          undefined,
            heightTableMain:    0,
            rows: [],
            selection: [],
            grouping: [],
            expandedGroups: [],
            filteringColumnExtensions: [],
            filters: [],
            expandedRowIds: [],
            enabledFilterRows: true,
            transacciones: [],
            setSelectedtransaccion:       null,
            isloadingtransaccion:         false,
            open_agregar:                 false,
            open_eliminar:                false,
            FACTURA_ELIMINAR:             null,
        }

        const VirtualTable_cellComponent =(CLICK)=> (props) => {
          const { column }    = props;
          const {row}         = props;

          if(column.name==='MONTO')
          {
            return(
              <Table.Cell {...props} style={{padding:0}}>
                {row.SIMBOLO+' '+row.MONTO}
              </Table.Cell>
              );
          }
      
          if(column.name==='BOTON')
          {
            if(row.ELIMINAR)
            {
              return(
              <Table.Cell {...props} style={{padding:0,paddingBottom:1}}>
                <Button color='primary' onClick={CLICK(row.ID_FACTURA)}  size="small" variant='contained' style={{textTransform: 'none',marginTop:0,marginBottom:0,padding:1}}>
                  Eliminar
                </Button>
              </Table.Cell>
              );
            }
            else
            {
              return(
                <Table.Cell {...props} style={{padding:0}}/>
              );
            }
          }
      
          return(
              <Table.Cell {...props} style={{padding:0}}/>
            );
      }

      this.VirtualTable_cellComponent=VirtualTable_cellComponent
        
    }; //FIN CONSTRUCTORS


onChangeAutocompletetransaccion = (event, newValue) =>{
  if (newValue!==null)
  {
    this.setState({setSelectedtransaccion :newValue});
  }
}


componentDidMount()
{
        let _this = this;
        _this.actualizarbarra(false)

        Auth.loggedIn().then( function(b){
          _this.setState({ isLoggin: b})
          if(b)
          {
            Request.get(`${ip}/TramitesAlumno/obtener_transacciones_alumno/${Auth.getProfile().user}`)
            .set({'authorization': 'Bearer ' + Auth.getToken() })
            .retry(1)
            .timeout({ response: 20000, deadline: 50000, }) 
            .end((err, res)=> {
             if (err) { 
                    if (err.toString().substr(0,16) === 'Error: Forbidden')
                    {
                      window.location.reload();
                      return;  
                    }
                    (async function() {
                        funciones.showToast('e','Error de conexión')
                        _this.setState({rows: []})
                    })();//FIN FUNCION ASYNC
                    return;
            }
            const tmp = JSON.parse(res.text);
            if(tmp.length>0){
              _this.setState({transacciones: tmp})
            }
          })
          
          Request.get(`${ip}/TramitesAlumno/obtener_tramites_pendientes_alumno/${Auth.getProfile().user}`)
            .set({'authorization': 'Bearer ' + Auth.getToken() })
            .retry(1)
            .timeout({ response: 20000, deadline: 50000, }) 
            .end((err, res)=> {
             if (err) { 
                    if (err.toString().substr(0,16) === 'Error: Forbidden')
                    {
                      window.location.reload();
                      return;  
                    }
                    (async function() {
                        funciones.showToast('e','Error de conexión')
                        _this.setState({rows: [], heightTableMain:   funciones.getHeightTableMain(movil_pequeño,_this).heightTable})
                    })();//FIN FUNCION ASYNC
                    return;
            }
            const tmp = JSON.parse(res.text);
            if(tmp.length>0){
                    _this.setState({ rows: tmp, heightTableMain: funciones.getHeightTableMain(movil_pequeño,_this).heightTable
                    }); 
                }
                else
                {
                    _this.setState({rows: [], heightTableMain:   funciones.getHeightTableMain(movil_pequeño,_this).heightTable})
                }
            _this.actualizarbarra(true)
          })
          }
        })
}

open_agregar=()=>{
  this.setState({open_agregar: true})
}

open_eliminar=(ID_FACTURA)=>event=>{
  this.setState({open_eliminar: true, FACTURA_ELIMINAR:ID_FACTURA})
}

cerrarmodal=()=>event=>{
  this.setState({open_agregar: false,open_eliminar: false,FACTURA_ELIMINAR: null})
}

guardar=(TIPO)=>event=>{

  this.setState({ openBackDrop: true }, ()=>{
    try{
    new Request
    .post(`${ip}/TramitesAlumno/gestion_tramite_alumno`)
    .set({'authorization': 'Bearer ' + Auth.getToken() })
    .set('Content-Type', 'application/json')
    .send({ ID_GESTION:(TIPO===1?this.state.setSelectedtransaccion.ID_GESTION:null),ID_FACTURA: (TIPO===2?this.state.FACTURA_ELIMINAR:null),cuenta_alumno: Auth.getProfile().user,TIPO: TIPO })
    .retry(0)
    .timeout({ response: 15000, deadline: 60000, }) 
    .end((err, res) => {
      if (err) { 
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        { 
          window.location.reload();
          return;  
        }       

        this.setState({ openBackDrop: false }, ()=> { 
          funciones.showToast('e', 'Error de conexión'); 
        });
      }

      const rows = JSON.parse(res.text);
      if (rows.length > 0) 
      {    
          if (rows[0].RESP === undefined)
         {   
            this.setState({openBackDrop: false}, ()=>{
              funciones.showToast('s', 'Proceso realizado correctamente.'); 
              this.setState({setSelectedtransaccion: null,open_agregar: false,open_eliminar: false,rows:rows})
            })
          }
          else{
                this.setState({ openBackDrop: false}, ()=>{
                  funciones.showToast('w', rows[0].RESP);
                });
          }
      }
      else
      {
        this.setState({ openBackDrop: false}, ()=>{
          this.setState({setSelectedtransaccion: null,open_agregar: false,open_eliminar: false,rows:[]});
        });
      }      
      });       
    }
    catch(ex){
      this.setState({ openBackDrop: false}, ()=>{
        funciones.showToast('e', 'Error de conexión');
      });
    }
  })
}

/*                                          RENDER                          */
render() {
    const { classes } = this.props;

    const botones_agregar = [
      {icono: 'Save',  nombre: 'Aceptar',escritura:true,onclick: this.guardar(1)
      , display:'auto'},
      {icono: 'Close',  nombre: 'Cerrar' ,onclick: this.cerrarmodal(), display:'auto', color: 'red'},
    ]
    const botones_eliminar = [
      {icono: 'Save',  nombre: 'Aceptar',escritura:true,onclick: this.guardar(2), display:'auto'},
      {icono: 'Close',  nombre: 'Cerrar' ,onclick: this.cerrarmodal(), display:'auto', color: 'red'},
    ]

    if (this.state.isLoggin === true )
    {
    return (    
    <React.Fragment>
      <Backdrop className={classes.backdrop}  open={this.state.openBackDrop}>
          <CircularProgress color="inherit" />
          <span style={{ marginTop: '10px' }}>{'Cargando...'}</span>
      </Backdrop>
    {/*--------------------------------------------------------------------DIALOG PARA AGREGAR---------------------------------------------------------------------*/}
    <Dialog
      open={this.state.open_agregar}
      disableEnforceFocus   disableAutoFocus
      fullWidth= {true} classes = {{ paper: classes.Dialog}}
      maxWidth= 'xs'
      style={{zIndex: 200000,}} //fullScreen={movil_pequeño?true:false}
    >
      <DialogTitle>
      <Typography component='span'  variant='subtitle2'>
      {'Transacción'}
      </Typography>
      </DialogTitle>
    <DialogContent>
            <Typography align='center'>
              ¿Está seguro de agregar la transacción?
            </Typography>
            </DialogContent>
            <BarraBotones botones={botones_agregar} l={this.l} e={this.e} i={this.i}/>
    </Dialog>
       {/*--------------------------------------------------------------------DIALOG PARA ELIMINAR---------------------------------------------------------------------*/}
    <Dialog
      open={this.state.open_eliminar}
      disableEnforceFocus   disableAutoFocus
      fullWidth= {true} classes = {{ paper: classes.Dialog}}
      maxWidth= 'xs'
      style={{zIndex: 200000,}} //fullScreen={movil_pequeño?true:false}
    >
      <DialogTitle>
      <Typography component='span'  variant='subtitle2'>
      {'Eliminar'}
      </Typography>
      </DialogTitle>
    <DialogContent>
            <Typography align='center'>
              ¿Está seguro de eliminar la transacción?
            </Typography>
            </DialogContent>
            <BarraBotones botones={botones_eliminar} l={this.l} e={this.e} i={this.i}/>
    </Dialog>

    {/*--------------------------------------------------------------------VENTANA PRINCIPAL--------------------------------------------------------------*/}

    <div style={{display:'flex',justifyContent:'center',alignItems:'center',marginBottom:15,marginTop:14,padding:0,flexDirection: !movil_pequeño ? "row" : "column",}}>
      <Autocomplete
        id="tramites"
        options={this.state.transacciones}  
        getOptionLabel={(option) =>option.DESCRIPCION + ' - ' +option.MONTO_ARANCEL}
        style={{ width: !movil ? '400px' : '100%' ,marginRight:!movil ? 5:0 }} 
        renderInput={(params) => <TextField {...params} label="Trámites" variant="outlined" style={{margin:0}}/>}
        value={this.state.setSelectedtransaccion}
        getOptionSelected = {(option, value) => option.ID_GESTION=== value.ID_GESTION}
        onChange={this.onChangeAutocompletetransaccion}   
        loading={this.state.isloadingtransaccion}
      />
      <Divider orientation="vertical" flexItem style={{ margin: !movil ? "5px 10px" : "5px 0px" }}/>
    {this.state.setSelectedtransaccion?
    <Button key='Button-habilitado' color='primary'  size="small" variant='contained' style={{textTransform: 'none',marginTop:0,marginBottom:0}}
      className={classes.button} classes={{iconSizeSmall: classes.iconSizeSmall }}
      startIcon={<Icono fontSize='small' icono={'Add'}  />}
      onClick={this.open_agregar}
    >
      Agregar
    </Button>
    :
    <Button key='Button-bloqueado' color='primary' disabled  size="small" variant='contained' style={{textTransform: 'none',marginTop:0,marginBottom:0}}
      className={classes.button} classes={{iconSizeSmall: classes.iconSizeSmall }}
      startIcon={<Icono fontSize='small' icono={'Add'}  />}
    >
      Agregar
    </Button>
    }
    </div>
    <div ref={this.tablaRef} style={{background:'white',marginLeft:movil_pequeño?globales.tabla.marginleft_movil:globales.tabla.marginleft,marginRight:movil_pequeño?globales.tabla.marginright_movil:globales.tabla.marginright}}>
    <CustomTable
      Columns={columns}                                    
      Rows={this.state.rows}                                          
      TableColumnExtensions={tableColumnExtensions}
      DefaultHiddenColumnNames={defaultHiddenColumnNames}
      getRowId = {getRowId}
      height={this.state.heightTableMain}
      enabledFilterRows= {false}
      standarPlugin = { <TableRowsIndexer/> }
      VirtualTable_cellComponent={this.VirtualTable_cellComponent(this.open_eliminar)}
      showSelectionColumn={false}
    />
    </div>
    </React.Fragment>
    ); /// finaliza return
    }
    else if (this.state.isLoggin === false)
    {
        Auth.logout()
        window.location.reload();
        return; 
    }


    return null;
} /// finaliza render
} /// finaliza class
)/// finaliza withStyles

    

    